var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQuestionmark({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_550_7133",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 1,
    y: 1,
    width: 18,
    height: 18
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.2852 9.4375C12.4961 9.22656 12.666 8.98047 12.7949 8.69922C12.9238 8.40625 12.9883 8.08984 12.9883 7.75C12.9883 6.92969 12.6953 6.22656 12.1094 5.64062C11.5352 5.05469 10.832 4.76172 10 4.76172C9.17969 4.76172 8.47656 5.05469 7.89062 5.64062C7.30469 6.21484 7.01172 6.91797 7.01172 7.75H8.48828C8.48828 7.35156 8.63477 7 8.92773 6.69531C9.23242 6.39062 9.58984 6.23828 10 6.23828C10.3984 6.23828 10.75 6.39062 11.0547 6.69531C11.3594 6.98828 11.5117 7.33984 11.5117 7.75C11.5117 7.96094 11.4707 8.1543 11.3887 8.33008C11.3066 8.50586 11.1953 8.66406 11.0547 8.80469L10.1406 9.75391C9.88281 10.0352 9.67188 10.3574 9.50781 10.7207C9.34375 11.0723 9.26172 11.4531 9.26172 11.8633V12.25H10.7383C10.7383 11.6875 10.8145 11.2656 10.9668 10.9844C11.1309 10.7031 11.3477 10.4219 11.6172 10.1406L12.2852 9.4375ZM10.7383 15.2383V13.7617H9.26172V15.2383H10.7383ZM10 2.51172C11.0312 2.51172 12.0039 2.70508 12.918 3.0918C13.832 3.49023 14.623 4.0293 15.291 4.70898C15.9707 5.37695 16.5098 6.16797 16.9082 7.08203C17.2949 7.98438 17.4883 8.95703 17.4883 10C17.4883 11.0312 17.2949 12.0039 16.9082 12.918C16.5098 13.832 15.9707 14.6289 15.291 15.3086C14.623 15.9766 13.832 16.5098 12.918 16.9082C12.0156 17.2949 11.043 17.4883 10 17.4883C8.96875 17.4883 7.99609 17.2949 7.08203 16.9082C6.16797 16.5098 5.37109 15.9766 4.69141 15.3086C4.02344 14.6289 3.49023 13.832 3.0918 12.918C2.70508 12.0156 2.51172 11.043 2.51172 10C2.51172 8.96875 2.70508 7.99609 3.0918 7.08203C3.49023 6.16797 4.02344 5.37695 4.69141 4.70898C5.37109 4.0293 6.16797 3.49023 7.08203 3.0918C7.98438 2.70508 8.95703 2.51172 10 2.51172Z",
    fill: "#0B0C0C"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_550_7133)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -2,
    y: -2,
    width: 24,
    height: 24,
    fill: "#546E7A"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuestionmark);
export default __webpack_public_path__ + "static/media/questionmark.3d9e73503df9f75b692db2f05870ba28.svg";
export { ForwardRef as ReactComponent };